import { useTranslation } from 'react-i18next';

import { changeLanguage, isLanguageCode, LANGUAGES, type LanguageCode } from '@/i18n';

/**
 * Language switcher shown in the top bar.
 *
 * Renders each language in its own script (العربية, کوردی) rather than in
 * English — staff pick their language by recognising it, not by reading a
 * translation of its name.
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (isLanguageCode(i18n.language) ? i18n.language : 'en') satisfies LanguageCode;

  return (
    <label className="flex items-center gap-2 text-sm text-content-secondary">
      <span aria-hidden="true">🌐</span>
      <span className="sr-only">Language</span>
      <select
        value={current}
        onChange={(event) => {
          const next = event.target.value;
          if (isLanguageCode(next)) void changeLanguage(next);
        }}
        className="cursor-pointer rounded-control border border-subtle bg-input px-2 py-1 text-content outline-none hover:bg-hover"
      >
        {Object.entries(LANGUAGES).map(([code, meta]) => (
          <option key={code} value={code}>
            {meta.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
}
